import React from 'react';
import { UserCircle, LogOut } from 'lucide-react';
import Logo from './Logo';

interface HeaderProps {
  onLogout: () => void;
  userData?: {
    firstName: string;
    lastName: string;
  } | null;
  onProfileClick?: () => void;
}

export default function Header({ onLogout, userData, onProfileClick }: HeaderProps) {
  return (
    <header className="bg-white shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex justify-between items-center">
          <div className="flex-shrink-0">
            <Logo className="h-8 md:h-10" />
          </div>
          <div className="flex items-center space-x-4">
            <button 
              onClick={onProfileClick}
              className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors"
            >
              <UserCircle className="w-6 h-6" />
              <span className="text-sm font-medium">
                {userData ? `${userData.firstName} ${userData.lastName}` : 'Loading...'}
              </span>
            </button>
            <button 
              onClick={onLogout}
              className="flex items-center space-x-1 text-gray-600 hover:text-gray-900 transition-colors"
            >
              <LogOut className="w-5 h-5" />
              <span className="text-sm">Logout</span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}